import script from "./GaleriaLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./GaleriaLightbox.vue?vue&type=script&setup=true&lang=js"

import "./GaleriaLightbox.vue?vue&type=style&index=0&id=3f90e88e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f90e88e"]])

export default __exports__